import React from 'react';

const VerifiedPill = () => {
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      // Emerald Green Gradient
      background: 'linear-gradient(135deg, #34d399 0%, #059669 100%)', 
      padding: '6px 12px',
      borderRadius: '20px',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.875rem',
      // Green Shadow
      boxShadow: '0 2px 4px rgba(5, 150, 105, 0.25)', 
      marginLeft: '12px',
      verticalAlign: 'middle'
    }}>
      {/* Small White Shield Icon */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
      <span>Verified Pro</span>
    </div>
  );
};

export default VerifiedPill;